import React from 'react'
import {getGraphQLEndpoint, getReactAppServerURL} from '../../common/environment/environmentManager'

interface Props {}

export const EnvironmentPage: React.FC<Props> = () => {
  return <EnvironmentInfo />
}

function EnvironmentInfo() {
  const apiBaseUrlEnv = process.env.REACT_APP_API_BASE_URL

  return (
    <div>
      React app server url: <b>{getReactAppServerURL()}</b>
      <br />
      React app server version: See <a href={`${getReactAppServerURL()}/api/version`}>{getReactAppServerURL()}/api/version</a>
      <br />
      React app GraphQL endpoint: <b>{getGraphQLEndpoint()}</b>
      <br />
      Version: See <a href="/version.json">/version.json</a>
      {process.env.NODE_ENV === 'development' && !apiBaseUrlEnv && (
        <>
          <hr />
          <div style={{color: '#b45309'}}>
            <b>Developer note:</b> <code>REACT_APP_API_BASE_URL</code> is not set.
            <br />
            This page therefore cannot determine the backend server URL.
            <br />
            <br />
            During development the React dev server may proxy API requests using the <code>proxy</code> field in <code>package.json</code>. That value
            cannot be read programmatically from the browser because it is only used by the development server and is not included in the compiled
            frontend bundle.
            <br />
            <br />
            If you want this page to display the backend URL, add the following to your <code>.env</code> file:
            <br />
            <code>REACT_APP_API_BASE_URL=&lt;same value as the "proxy" field in package.json&gt;</code>
          </div>
        </>
      )}
    </div>
  )
}
